<template>
  <div class="filter-view">
    <div class="flex-row">
    <h1 class="title">Etiketler</h1>
    </div>
    <div class="justify-end-div">
      <div class="log-icon-wrapper">
        <img src="@/assets/images/logIconNew.svg" @click="onLogAction" class="log-icon" />
        <span class="tooltip">{{ $t('log_records') }}</span>
      </div>
      <div class="justify-end-add-btn no-text-select" @click="addNewTag">
        <img src="../../assets/images/plus.svg">
        <span>{{$t('add_new')}}</span>
      </div>
    </div>
  </div>

  <div class="table-container">
    <table class="content-table">
      <thead class="header-table">
      <tr class="trhead">
        <th @click="handleSort('name')" class="sortable-header">
          {{$t('name_journeys')}}
          <img
              src="../../assets/images/status.svg"
              class="sort-icon"
              :class="getSortClass('name')"
          >
        </th>
        <th @click="handleSort('status')" class="sortable-header">
          {{$t('status')}}
          <img
              src="../../assets/images/status.svg"
              class="sort-icon"
              :class="getSortClass('status')"
          >
        </th>
        <th class="text-right">{{$t('actions_payment')}}</th>
      </tr>
      </thead>
      <tbody class="tbody-container">
      <tr class="tr-class" v-if="!loading" v-for="tag in tags" >
        <td class="td-style">
          <span class="category-tag" :class="tag.color">{{ tag.name }}</span>
        </td>
        <td class="td-style">
          <span class="test-class">{{tag.status ? this.$t('active') : this.$t('disabled')}}</span>
        </td>
        <td class="td-style action-icons text-right">
          <img src="@/assets/images/trashOutline.svg" alt="Delete" class="action-icon" @click="() => deleteTag(tag.tagId)" />
          <img src="@/assets/images/editPenOutline.svg" alt="Edit" class="action-icon" @click="() => editTag(tag)" />
        </td>
      </tr>
      <tr v-else>
        <td colspan="3" class="table-loading">
          <VueSpinner size="16" height="100%" color="#8c8c8c" />
          <span class="text">{{$t('loading')}}</span>
        </td>
      </tr>
      <tr v-if="!loading && tags.length === 0 ">
        <td colspan="3" class="table-loading">
          <span class="text">{{$t('no_data_found')}}</span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import AddUserModal from '@/components/modals/InviteUserModal.vue';
import FilterModal from '@/components/tables/Company/CompanyFilterModal.vue';
import CompanyFieldFilter from '@/components/table-filters/CompanyFieldFilter.vue';
import ProgramFilter from "@/components/table-filters/NumberFilter.vue";
import UserAmountFilter from "@/components/table-filters/MinMaxNumberFilter.vue";
import PaymentVolume from "@/components/table-filters/PaymentVolume.vue";
import DateFilter from "@/components/table-filters/DateFilter.vue";
import {VueSpinner} from "vue3-spinners";
import ExpandableSearch from "@/components/ExpandableSearch.vue";

export default {
  components: {
    DateFilter,
    PaymentVolume,
    UserAmountFilter,
    AddUserModal,
    FilterModal,
    CompanyFieldFilter,
    ProgramFilter,
    ExpandableSearch,
    VueSpinner
  },
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    addNewTag: {
      type: Function,
      default: () => {}
    },
    editTag: {
      type: Function,
      default: () => {}
    },
    deleteTag: {
      type: Function,
      default: () => {}
    },
    tags: {
      type: Array,
      default: []
    },
    onLogAction:{
      type:Function,
      default:()=>{}
    },
    currentSort: {
      type: Object,
      default: () => ({ column: null, direction: null })
    },
    onSort: {
      type: Function,
      required: false,
      default: () => {}
    }
  },
  data() {
    return {
      showModal: false,
      selectAll:false,
      showFilter:false,
      searchText: '',
    }
  },
  methods: {
    handleSort(column) {
      let newDirection = 'asc';

      // Eğer aynı kolona tıklanıyorsa direction'ı değiştir
      if (this.currentSort.column === column) {
        if (this.currentSort.direction === 'asc') {
          newDirection = 'desc';
        } else if (this.currentSort.direction === 'desc') {
          // desc'den sonra sıralamayı kaldır
          this.onSort(null, null);
          return;
        }
      }

      this.onSort(column, newDirection);
    },

    getSortClass(column) {
      if (this.currentSort.column !== column) {
        return 'sort-default';
      }

      if (this.currentSort.direction === 'asc') {
        return 'sort-asc';
      } else if (this.currentSort.direction === 'desc') {
        return 'sort-desc';
      }

      return 'sort-default';
    }
  },

}
</script>

<style>
.sortable-header {
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s;
}

.sortable-header:hover {
  background-color: #f5f5f5;
}

.sort-icon {
  width: 16px;
  height: 16px;
  margin-left: 4px;
  vertical-align: middle;
  transition: transform 0.3s ease, opacity 0.3s ease;
  display: inline-block;
  opacity: 0.4;
}

.sortable-header:hover .sort-icon {
  opacity: 0.6;
}

.sort-icon.sort-asc,
.sort-icon.sort-desc {
  opacity: 1;
}

.sort-icon.sort-asc {
  transform: rotate(0deg);
}

.sort-icon.sort-desc {
  transform: rotate(180deg);
}

.sort-icon.sort-default {
  transform: rotate(0deg);
  opacity: 0.4;
}

.flex-row{
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  position: relative;
  gap: 5px;
  align-items: center;
  font-size: 12px;
  color: #344054;
  font-feature-settings: 'clig' off, 'liga' off;
}

.title{
  font-family: euclid_medium, sans-serif;
  font-size: 20px;
  color: #040C2D;
}

.filter-view{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  width: 100%;
  min-height: 52px;
}
.justify-end-div{
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  justify-content: center;
}

.name-row span {
  font-family: euclid_medium, sans-serif;
  color: #000;
}

.name-row:hover.name-row span{
  color: #4A68F8;
}

.flags img {
  height: 18.66px;
  width: 28px;
  border-radius: 4px;
}

.category-tag {
  margin-right: 5px;
}

.category-tag.primary {
  background-color: #4A68F8;
  color: #FFF;
}

.category-tag.warning {
  background-color: #FF8E55;
  color: #FFF;
}

.category-tag.danger {
  background-color: #FF5B5B;
  color: #FFF;
}

.category-tag.success {
  background-color: #00D68F;
  color: #FFF;
}

.text-right {
  text-align: right;
}

.action-icons {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  justify-content: flex-end;
}

.action-icon {
  width: 18px;
  height: 18px;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
}

.log-icon-wrapper {
  display: flex;
  position: relative;
  cursor: pointer;
  align-self: center;
}
.log-icon{
  width: 24px;
  height: 24px;
}
</style>
